import create from "zustand";

const overlayStore = (set) => ({
	showCreateBook: false,
	setShowCreateBook: (flag) => set({ showCreateBook: flag }),

	showCreateUser: false,
	setShowCreateUser: (flag) => set({ showCreateUser: flag }),

	showCreateCategory: false,
	setShowCreateCategory: (flag) => set({ showCreateCategory: flag }),

	showCreateCollection: false,
	setShowCreateCollection: (flag) => set({ showCreateCollection: flag }),

	showCreateSubscription: false,
	setShowCreateSubscription: (flag) => set({ showCreateSubscription: flag }),

	showCreateRate: false,
	setShowCreateRate: (flag) => set({ showCreateRate: flag }),

	showUploadBooks: false,
	setShowUploadBooks: (flag) => set({ showUploadBooks: flag }),

	showUploadUsers: false,
	setShowUploadUsers: (flag) => set({ showUploadUsers: flag }),

	showCreateSubjectGroups: false,
	setShowCreateSubjectGroups: (flag) => set({ showCreateSubjectGroups: flag }),

	showListOfPicksToRetain: false,
	setShowListOfPicksToRetain: (flag) => set({ showListOfPicksToRetain: flag }),
});

const useOverlayStore = create(overlayStore);

export default useOverlayStore;
